import {ButtonGroup} from '../ButtonGroup';

import type {ButtonGroupItemDef} from '../ButtonGroup';

export interface ModalSubNavProps {
  items: ButtonGroupItemDef[];
  value: string;
  onChange: (value: string) => void;
}

export function ModalSubNav({items, value, onChange}: ModalSubNavProps) {
  return (
    <div
      data-slot="modal-sub-nav"
      className="-mx-6 shrink-0 border-b border-border bg-background-secondary px-6 py-3"
    >
      <ButtonGroup items={items} value={value} onChange={onChange} />
    </div>
  );
}
